/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./reload.component";
import * as i2 from "@angular/common";
import * as i3 from "../universal-config";
var styles_ReloadComponent = [];
var RenderType_ReloadComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_ReloadComponent, data: {} });
export { RenderType_ReloadComponent as RenderType_ReloadComponent };
export function View_ReloadComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 0, "div", [], null, null, null, null, null))], null, null); }
export function View_ReloadComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "nns-reload", [], null, null, null, View_ReloadComponent_0, RenderType_ReloadComponent)), i0.ɵdid(1, 114688, null, 0, i1.ReloadComponent, ["isBrowser", i2.APP_BASE_HREF, i3.Config], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var ReloadComponentNgFactory = i0.ɵccf("nns-reload", i1.ReloadComponent, View_ReloadComponent_Host_0, {}, {}, []);
export { ReloadComponentNgFactory as ReloadComponentNgFactory };
//# sourceMappingURL=reload.component.ngfactory.js.map